<template>
<main>
  <slot name="sidebar"></slot>
  <slot name="top"></slot>
  <div class="content-wrapper">
    <columns>
      <column size="is-two-thirds">
        <slot name="left"></slot>
      </column>
      <column>
        <slot name="right"></slot>
      </column>
    </columns>
  </div>
</main>
</template>

<script>
import Container from '@/components/general/container'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'

export default {
  components: { Columns, Column, Container }
}
</script>



// WEBPACK FOOTER //
// src/templates/profile-layout.vue